module.exports = __webpack_public_path__ + "static/img/product_society_society_ffpjcbf.78c5daa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_ffpjcbf.png
// module id = TYK7
// module chunks = 0